var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33333 7.5H8.66667V8.83333H3.33333V7.5ZM4.66667 12.8333H2V2.16666H6.66667V5.5H10V7.56666L11.3333 6.23333V4.83333L7.33333 0.833328H2C1.64638 0.833328 1.30724 0.973804 1.05719 1.22385C0.807144 1.4739 0.666668 1.81304 0.666668 2.16666V12.8333C0.666668 13.187 0.807144 13.5261 1.05719 13.7761C1.30724 14.0262 1.64638 14.1667 2 14.1667H4.66667V12.8333ZM3.33333 11.5H6.06667L6.66667 10.9V10.1667H3.33333V11.5ZM11.4667 8.16666C11.5333 8.16666 11.6667 8.23333 11.7333 8.3L12.6 9.16666C12.7333 9.3 12.7333 9.56666 12.6 9.7L11.9333 10.3667L10.5333 8.96666L11.2 8.3C11.2667 8.23333 11.3333 8.16666 11.4667 8.16666ZM11.4667 10.7667L7.4 14.8333H6V13.4333L10.0667 9.36666L11.4667 10.7667Z",
    fill: "#7100DA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotes);
export default __webpack_public_path__ + "static/media/notes.e73a877e086a4575d55948c5c0872d56.svg";
export { ForwardRef as ReactComponent };